import { render, staticRenderFns } from "./control6Property.vue?vue&type=template&id=82b2641a&scoped=true&"
import script from "./control6Property.vue?vue&type=script&lang=js&"
export * from "./control6Property.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b2641a",
  null
  
)

export default component.exports